import React, { useState, useEffect } from "react";
import AddEditEmployee from "../components/employee/AddEditemployee";
import { useParams } from "react-router-dom"; // Import useParams
import { useGetEmployeeQuery } from "../store/employee/EmployeeApiSlice";
import { useSelector } from "react-redux";
import { selectCurrentUserObject } from "../store/auth/authSlice";

const EmployeeFormPage = ({ isEdit }) => {
  const { id } = useParams(); // Get the ID from the URL
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const user = useSelector(selectCurrentUserObject);

  // Always call the hook, but conditionally use its result
  const {
    isLoading,
    data: employeeReturned,
    error: isEmployeeError,
    refetch: refetchEmployee,
  } = useGetEmployeeQuery({query: `org_id=${user?.company}`,
    employee_id: isEdit ? id : null, // Use the ID from useParams
  },{ skip: !user?.company });

  useEffect(() => {
    if (isEdit && !isLoading && employeeReturned) {
      setSelectedEmployee(employeeReturned.data[0]);
    } else {
      setSelectedEmployee(null);
    }
  }, [isEdit, isLoading, employeeReturned]);

  return (
    <>
      <AddEditEmployee
        selectedEmployee={selectedEmployee}
        isEditEmployee={isEdit}
      />
    </>
  );
};

export default EmployeeFormPage;
